export const copyElem = () => {
  CopySnsLink();
  CopyLangNav();
};

//pc,spレイアウトが異なるため要素をcopy
const CopySnsLink = () => {
  $('.footer-links').after($('.js-sns').clone());
};

//menu内に同じ記載するのが面倒なのでcopy
const CopyLangNav = () => {
  $('.menu').find('.nav-icon').after($('.js-lang').clone());
};
